import React, { useState } from "react";
import { toast } from "sonner";
import { FileText, FileSpreadsheet, Loader2, Download } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { authApi } from "../../lib/auth";
import { errorMessage } from "../../lib/api";
import { downloadBlob } from "../../utils/exporters";

const NAME = (kind) => (kind === "executive" ? "Executive summary (PDF)" : kind === "detailed" ? "Detailed report (PDF)" : "Findings (CSV)");

/** Server-generated report downloads, honoring the current level / E5 / unassessed toggles. */
export default function ReportButtons({ scanId, params, slug }) {
  const [busy, setBusy] = useState("");
  const download = async (kind) => {
    setBusy(kind);
    try {
      const blob = await authApi.compliance.report(scanId, { ...params, kind });
      downloadBlob(blob, `cis-m365-${slug}-L${params.level}-${kind === "csv" ? "findings.csv" : `${kind}.pdf`}`, kind === "csv" ? "text/csv;charset=utf-8" : "application/pdf");
      toast.success(`${NAME(kind)} downloaded`);
    } catch (err) {
      toast.error("Report failed", { description: errorMessage(err) });
    } finally {
      setBusy("");
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="tb-btn primary" disabled={!!busy} data-testid="cis-report-menu">
          {busy ? <Loader2 size={14} className="spin" /> : <Download size={14} />} Reports
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[240px]">
        <DropdownMenuLabel>Level {params.level} · {params.unassessed === "fail" ? "unassessed = fail" : "unassessed excluded"}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => download("executive")} data-testid="cis-report-executive">
          <FileText size={14} /> {NAME("executive")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => download("detailed")} data-testid="cis-report-detailed">
          <FileText size={14} /> {NAME("detailed")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => download("csv")} data-testid="cis-report-csv">
          <FileSpreadsheet size={14} /> {NAME("csv")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
